import { createSlice, PayloadAction } from "@reduxjs/toolkit";
interface AppliedFilter {
    id: number;
    propName: string;
    selectedOption: any;
}

interface SearchState {
    selectedDegree: string,
    searchText: string,
    filtersList: any[];
    collegeList: any[];
    appliedFilters: Record<string, any>;
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    selectedFilters: string[];
    selectedCollegeIndex: number[];
    selectedAddToListIndex: number[];
    selectedSortBy: string;
    totalCollegeList: number;
    searchedList: any[],
    isClearAll: boolean,
    drawerOpen: boolean;
    showAdvancedFilters: boolean;
    showPremiumFilters: boolean;
    isLoading: boolean;
    hasMore: boolean;
    hasError: boolean;
    skipCount: number;
    courseData: any[];
    isCourse: boolean;
    totCourseList: number;
    courseCipCode: number;
    courseShortlistData: any[];
    clearAllTriggered: boolean;
    searchTexts: string;
    courseSearchList: any[];
    isRole:boolean;
    courseSocCode: number;
    searchType:string;
    isFromSearch: boolean;
    roleList: any[];
    totRoleList: number;  
    roleShortlistData: any[];
    roleSearchList: any[];  
    roleData: any[];
}

const initialState: SearchState = {
    selectedDegree: "master",
    searchText: '',
    filtersList: [],
    collegeList: [],
    appliedFilters: {},
    status: 'idle',
    selectedFilters: [],
    selectedCollegeIndex: [],
    selectedAddToListIndex: [],
    selectedSortBy: 'popularity',
    totalCollegeList: 0,
    searchedList: [],
    isClearAll: false,
    drawerOpen: false,
    showAdvancedFilters: false,
    showPremiumFilters: false,
    isLoading: false,
    hasMore: true,
    hasError: false,
    skipCount: 0,
    courseData: [],
    isCourse: false,
    totCourseList: 0,
    courseCipCode: 0,
    courseShortlistData: [],
    clearAllTriggered: false,
    searchTexts: '',
    courseSearchList: [],
    isRole: false,
    courseSocCode: 0,
    searchType:"",
    isFromSearch:false,
     roleList: [],
    totRoleList: 0,  
    roleShortlistData: [],
    roleSearchList: [],  
    roleData: []
}

const searchSlice = createSlice({
    name: "searchData",
    initialState,
    reducers: {
        selectedDegreeChanage: (state, action) => {
            state.selectedDegree = action.payload;
        },
        degreeSearchChange: (state, action) => {
            state.searchText = action.payload;
        },
        setSearchedList: (state, action) => {
            state.searchedList = action.payload;
        },
        setFiltersList: (state, action) => {
            state.filtersList = action.payload;
        },
        setCollegeList: (state, action) => {
            state.collegeList = action.payload;
        },
        setTotalCollegeList: (state, action) => {
            state.totalCollegeList = action.payload;
        },
        setRoleData: (state, action) =>{
            state.roleData = action.payload;
        },
        applySort: (state, action) => {
            state.selectedSortBy = action.payload;
        },
        addFilter: (state, action: PayloadAction<string>) => {
            if (!state.selectedFilters.includes(action.payload)) {
                state.selectedFilters.push(action.payload);
            }
        },
        clearFilters: (state) => {
            state.selectedFilters = [];
        },
        setSelectedCollegeIndex: (state, action: PayloadAction<number>) => {
            if (!state.selectedCollegeIndex.includes(action.payload)) {
                state.selectedCollegeIndex.push(action.payload);
            }
        },
        setSelectedAddToListIndex: (state, action: PayloadAction<number>) => {
            const index = action.payload;
            if (state.selectedAddToListIndex.includes(index)) {
                // Remove the index if it exists
                state.selectedAddToListIndex = state.selectedAddToListIndex.filter(i => i !== index);
            } else {
                state.selectedAddToListIndex.push(index);
            }
        },
        updateAppliedFilter: (state, action: PayloadAction<AppliedFilter>) => {
            const { id, propName, selectedOption } = action.payload;
            const index = state.filtersList.findIndex(item => item.id === id && item.propName === propName);

            if (index !== -1) {
                state.filtersList[index].selectedOption = selectedOption;
            }
        },

        clearAppliedFilter: (state, action: PayloadAction<{ id: number; propName: string }>) => {
            const { id, propName } = action.payload;
            const index = state.filtersList.findIndex(item => item.id === id && item.propName === propName);

            if (index !== -1) {
                const { selectedOption, ...rest } = state.filtersList[index];
                state.filtersList[index] = rest;
            }
        },

        clearAllFilters: (state) => {
            state.filtersList = state.filtersList.map(({ selectedOption, ...rest }) => rest);
            state.isClearAll = true
        },
        setClearAll: (state) => {
            state.clearAllTriggered = true;
        },
        resetClearAll: (state) => {
            state.isClearAll = false;

            state.clearAllTriggered = false;
        },

        setDrawerOpen: (state, action: PayloadAction<boolean>) => {
            state.drawerOpen = action.payload;
        },
        setShowAdvancedFilters: (state, action: PayloadAction<boolean>) => {
            state.showAdvancedFilters = action.payload;
        },
        setShowPremiumFilters: (state, action: PayloadAction<boolean>) => {
            state.showPremiumFilters = action.payload;
        },
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setHasMore: (state, action: PayloadAction<boolean>) => {
            state.hasMore = action.payload;
        },
        setHasError: (state, action: PayloadAction<boolean>) => {
            state.hasError = action.payload;
        },
        setSkipCount: (state, action: PayloadAction<number>) => {
            state.skipCount = action.payload;
        },
        setCourseData(state, action: PayloadAction<any>) {
            state.courseData = action.payload;
        },
        setIsCourse(state, action: PayloadAction<any>) {
            state.isCourse = action.payload;
        },
        setTotCourseList(state, action: PayloadAction<number>) {
            state.totCourseList = action.payload;
        },
        setTotRoleList(state, action: PayloadAction<number>) {
            state.totRoleList = action.payload;
        },
        setCourseCipCode(state, action: PayloadAction<number>) {
            state.courseCipCode = action.payload;
        },
        setCourseSocCode(state, action:PayloadAction<any>){
            state.courseSocCode = action.payload;
        },
        setCourseShortlistData(state, action: PayloadAction<any>) {
            state.courseShortlistData = action.payload;
        },
        setSearchText: (state, action: PayloadAction<string>) => {
            state.searchTexts = action.payload;
        },
        setCourseSearchList: (state, action) => {
            state.courseSearchList = action.payload;
        },
        setIsRole:(state, action)=>{
            state.isRole =action.payload;
        },
        setSearchType:(state,action)=>{
            state.searchType = action.payload;
        },
        setIsFromSearch:(state,action)=>{
            state.isFromSearch = action.payload;
        },
        clearSearchState: () => initialState,

    },
})

export const {
    selectedDegreeChanage,
    setFiltersList,
    addFilter,
    clearFilters,
    degreeSearchChange,
    setSelectedCollegeIndex,
    setSelectedAddToListIndex,
    updateAppliedFilter,
    clearAppliedFilter,
    clearAllFilters,
    setCollegeList,
    applySort,
    setTotalCollegeList,
    setSearchedList,
    setClearAll,
    resetClearAll,
    setDrawerOpen,
    setShowAdvancedFilters,
    setShowPremiumFilters,
    setIsLoading,
    setHasMore,
    setHasError,
    setSkipCount,
    setCourseData,
    setRoleData,
    setIsCourse,
    setIsRole,
    setTotCourseList,
    setTotRoleList,
    setCourseCipCode,
    setCourseSocCode,
    setCourseShortlistData,
    setSearchText,
    setCourseSearchList,
    setSearchType,
    setIsFromSearch,
    clearSearchState
} = searchSlice.actions
export default searchSlice.reducer;

